import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
export * from './assignment-history-layer';
export * from './auth';
export * from './common';
export * from './common-inquiry-board';
export * from './common-inquiry-board-answer';
export * from './common-notice';
export * from './common-notice-receive';
export * from './contracted-foreign-business';
export * from './define-document-area';
export * from './define-document-download';
export * from './device-log';
export * from './device-mobile';
export * from './device-tablet';
export * from './district-allow-ip';
export * from './fm1-01-default-info-unit';
export * from './footer-info';
export * from './foreign-applicant';
export * from './foreign-dashboard';
export * from './foreign-default-info-unit';
export * from './foreign-program';
export * from './foreign-system-unit';
export * from './foreign-user';
export * from './m-select-lodging-popup';
export * from './pa2-01-assignment-calendar';
export * from './public-work-history-layer';
export * from './search-filter';
export * from './system-unit';
export * from './system-user';
export * from './us1-01-unit-setting';
export * from './work-history-layer';
export * from './worker-applicant';
export * from './worker-assignment';
export * from './worker-assignment-franchise';
export * from './worker-assignment-public';
export * from './worker-audit-monitoring';
export * from './worker-change-work-place';
export * from './worker-dashboard';
export * from './worker-document';
export * from './worker-extension-stay';
export * from './worker-franchise';
export * from './worker-lodging';
export * from './worker-program';
export * from './worker-program-status';
export * from './worker-public-salary';
export * from './worker-recommender';
export * from './worker-salary';
export * from './worker-unauthorized-departure';
export * from './worker-user';

import { persistor, store } from './store.redux';

export type RootState = ReturnType<typeof store.getState>;
export const GlobalDispatch = store.dispatch;

export type AppDispatch = typeof GlobalDispatch;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;

export { persistor, store };
